module.exports = __webpack_public_path__ + "f1c75c9ef4a8c18a32d95bced4a48405.png";